<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>服务单详情
      </div>
    </div>

    <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd;margin-top:30px;">
      <div class="form-title">
        <div style="margin-left:30px;line-height:46px">服务单信息</div>
      </div>
      <div style="height:16px;wiidth:100%;background:#fff"></div>
      <div class="table">
        <table class="tab_box">
          <tr class="tab_tr">
            <th class="tab_th">服务单号</th>
            <td class="tab_td">{{orderCode}}</td>
          </tr>

          <tr class="tab_tr">
            <th class="tab_th">申请状态</th>
            <td class="tab_td" style="color: #f64e62;">{{status}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">申请时间</th>
            <td class="tab_td">{{create_date1}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">用户账号</th>
            <td class="tab_td">{{mobile}}</td>
          </tr>
          <div style="height:20px"></div>
          <tr class="tab_tr">
            <th class="tab_th">退款金额</th>
            <td class="tab_td">￥{{pay_money}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">确认退款金额</th>
            <td class="tab_td">
              <el-input :disabled="show1" style="width:33%" v-model="refund"></el-input>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">退款方式</th>
            <td class="tab_td">原路径返回</td>
          </tr>

          <tr class="tab_tr">
            <th class="tab_th">退款原因</th>
            <td class="tab_td">{{cause}}</td>
          </tr>
          <div style="height:20px"></div>
          <tr class="tab_tr">
            <th class="tab_th">处理备注</th>
            <td class="tab_td">
              <el-input :disabled="show1" style="width:33%" v-model="remark"></el-input>
            </td>
          </tr>
        </table>
        <div style="width:300px;height:150px;margin:0 auto;margin-top:30px;" v-if="show != 4">
          <el-row>
            <el-button style="margin-left:50px;" type="success" @click="submit()">确认退款</el-button>
            <el-button type="danger" @click="reject()">拒绝退款</el-button>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
   

<script>
export default {
  name: "gallery",
  data() {
    return {
      serve: this.$store.state.serve,
      username: "",
      token: "",
      id: this.$route.params.id,
      orderCode: "",
      status: "",
      cause: "",
      create_date1: "",
      mobile: "",
      pay_money: "",
      return_money_to: "",
      return_type: "",
      refund: "",
      remark: "",
      show: true,
      show1: false
    };
  },
  created() {
    this.$store.state.leftTitle = "退款申请处理";
    this.$store.state.topActiveId = 3;
    this.geting();
  },

  methods: {
    reject() {
      //拒绝退款
      const _this = this;
      if (this.remark == "") {
        this.$message.error("请输入处理备注");
        return;
      }
      this.axios
        .get(this.serve + "/admin/return_money_operate", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            remark: this.remark,
            res: 3
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.success(res.data.msg);
            this.$router.push("/admin/d_refund");
          } else {
            this.error(res.data.msg);
          }
        });
    },
    error(msg) {
      this.$message({
        type: "error",
        message: msg
      });
    },
    success(msg) {
      this.$message({
        type: "success",
        message: msg
      });
    },
    submit(id) {
      //同意退款
      if (this.refund == "") {
        this.$message.error("请确定退款金额");
        return;
      }

      if (this.remark == "") {
        this.$message.error("请输入处理备注");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const _this = this;
      this.axios
        .get(this.serve + "/admin/return_money_operate", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            remark: this.remark,
            sure_return_money: this.refund,
            res: 4
          }
        })
        .then(res => {
          loading.close();
          if (res.data.status == "success") {
            this.success(res.data.msg);
            this.$router.push("/admin/d_refund");
          } else {
            this.error(res.data.msg);
          }
        });
    },
    geting(id) {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/return_money_detail", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          var json = res.data.data;
          this.show = json.status;

          if (json.status == "1") {
            json.status = "待处理";
          }
          if (json.status == "4") {
            json.status = "已退款";

            that.show1 = true;
            that.refund = json.sure_return_money;
            that.remark = json.remark;
          }
          if (json.status == "3") {
            json.status = "已拒绝";
            that.show = false;
            that.show1 = true;
            that.refund = json.sure_return_money;
            that.remark = json.remark;
          }
          var time = json.create_date;
          var timeNew = new Date(parseInt(time) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
          json.create_date = timeNew;
          that.orderCode = json.code;
          that.status = json.status;
          that.cause = json.cause;
          (that.create_date1 = json.create_date), (that.mobile = json.mobile);
          that.pay_money = json.return_money;
          that.return_money_to = json.return_money_to;
          that.return_type = json.return_type;
        });
    }
  }
};
</script>

<style lang="scss">
.topBar {
  margin-bottom: 40px;
  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
.table {
  background: #fff;
  padding-bottom: 100px;
  .tab_box {
    width: 97%;
    margin: 0 auto;

    .tab_tr {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(221, 221, 221, 1);
      .tab_th {
        padding: 0;
        margin: 0;
        width: 160px;
        height: 50px;
        background: rgba(245, 250, 249, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        text-align: right;
        padding-right: 40px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .tab_td {
        padding: 0;
        margin: 0;
        border: 1px solid rgba(221, 221, 221, 1);
        padding-left: 20px;
        font-size: 14px;

        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.filtrate {
  width: 1060px;
  margin-left: 420px;
  // background: orange;

  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }

    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}

.brand-page {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 50px;
  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }

  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>

